import { post,get } from "./http";

const commonApi = {
  listCodeSet: (params) => {
    return post("/product/listCodeSet", params);
  },
  lngListSeller: (params) => {
    return post(`/common/lng/listSeller`, params);
  },
  captcha: () => {
    return get(`/n/captcha`);
  },//获取图片
  accountCheck: (params) => {
    return get(`/n/forgot/account/check`,params);
  },//重置密码页面-图片验证码校验
  forgotAccountFind: (params) => {
    return get(`/n/forgot/account/find`,params);
  },//发送验证码
};

export default commonApi;
